import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MpsUserService } from '../services/mps-user.service';
import { mpsRouteNames } from '../mps-route-names';

export const MpsLoggedInGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);

  return userService.isLoggedIn() ? true : router.navigateByUrl(mpsRouteNames.auth + '/' + mpsRouteNames.login);
};
